import { createContext } from 'react';

const value = {
  followedBrands: [],
  availableBrands: [],
  toggleFollowBrand() {
    console.warn('UserContext.toggleFollowBrand not implemented');
  },
  isBrandFollowedByUser() {
    console.warn('UserContext.isBrandFollowedByUser not implemented');
    return undefined;
  },
  setAvailableBrands() {
    console.warn('UserContext.setAvailableBrands not implemented');
  },
};

export const FollowBrandContext = createContext(value);
